var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history"},[_c('v-data-table',{attrs:{"headers":_vm.headers.length ? _vm.headers : _vm.tableHeaders,"items":_vm.items,"disableSort":true,"hideDefaultFooter":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }